const SERVER = '/api'
// const SERVER = 'http://3.89.54.100:8080/nakdan'

export const AppConfig = {
  SERVER: SERVER,
  SHOW_PASUK_FONT: true,
  INCLUDE_TALMUD_GENRE: false,
  IN_KETIV_MALEH_AUTO_ADD_AIMS: false,
  ALWAYS_SHOW_QAMATZ_QATAN_BUTTON: true,
  PASSWORD_CHANGING: false
}
